/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import useStyles from './ShopByFilterStyles';
import ShopByCardBuilder from './ShopByCardBuilder';

const ShopByFilter = (props) => {
    const { data } = props;
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:770px)');

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    speed: 500,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    speed: 500,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: true,
                    infinite: true,
                    speed: 500,
                },
            },
        ],
    };

    const renderCategories = data.map((category) => (
        <ShopByCardBuilder category={category} classes={classes} />
    ));

    return (
        <>
            {<div className={`${classes.shopByFilterTitle} shop-by-filter-title`}>SELECT THE PLANT THAT'S RIGHT FOR YOU</div>}{/* eslint-disable-line */}
            {matches
                ? (
                    <Slider className={`slider-container ${classes.shopBySection} shopBySectionWrapper slider-margin`} {...settings}> {/* eslint-disable-line */}
                        {renderCategories}
                    </Slider>
                )
                : (
                    <Container style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
                        <Grid container className={`${classes.shopBySection} shopBySectionWrapper`}>
                            {renderCategories}
                        </Grid>
                    </Container>
                )}
        </>
    );
};

ShopByFilter.propTypes = {
    data: PropTypes.object.isRequired,
};

export default ShopByFilter;
